const LandingSection2 = () => {
  return (
    <div className="serviceBox">
      <div className="container">
        <div className="serviceinrBox">
          <div className="row">
            <div className="col-md-12">
              <div className="serviceinrheader">
                <h2 className="commanheading fontColorWhite">
                  Give us a Chance
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="serviceIcnBox">
                <div className="serviceIcnBoxicn">
                  <a className="navbar-brand" href="#">
                    <img
                      className=""
                      src={require("../../assets/images/ShieldCheck.png")}
                      alt="ShieldCheck"
                    />
                  </a>
                </div>
                <div className="serviceIcnBoxtitle">
                  <p> Safe &amp; Secure </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serviceIcnBox">
                <div className="serviceIcnBoxicn">
                  <a className="navbar-brand" href="#">
                    <img
                      className=""
                      src={require("../../assets/images/Group-line.png")}
                      alt="Group-line"
                    />
                  </a>
                </div>
                <div className="serviceIcnBoxtitle">
                  <p> Detailed Family Information </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serviceIcnBox">
                <div className="serviceIcnBoxicn">
                  <a className="navbar-brand" href="#">
                    <img
                      className=""
                      src={require("../../assets/images/CircleWavyCheck.png")}
                      alt="CircleWavyCheck"
                    />
                  </a>
                </div>
                <div className="serviceIcnBoxtitle">
                  <p> Verified Profiles </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingSection2;
